var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _path = require('path');

var http = require('http');

var https = require('https');

var qs = require('querystring');

var zlib = require('zlib');

var _require = require('url'),
    URL = _require.URL;

var CentraResponse = require('./CentraResponse.js');

var supportedCompressions = ['gzip', 'deflate'];

module.exports =
/*#__PURE__*/
function () {
  "use strict";

  function CentraRequest(url) {
    var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';

    _classCallCheck(this, CentraRequest);

    this.url = typeof url === 'string' ? new URL(url) : url;
    this.method = method;
    this.data = null;
    this.sendDataAs = null;
    this.reqHeaders = {};
    this.streamEnabled = false;
    this.compressionEnabled = false;
    this.timeoutTime = null;
    this.coreOptions = {};
    this.resOptions = {
      'maxBuffer': 50 * 1000000 // 50 MB

    };
    return this;
  }

  _createClass(CentraRequest, [{
    key: "query",
    value: function query(a1, a2) {
      var _this = this;

      if (typeof a1 === 'object') {
        Object.keys(a1).forEach(function (queryKey) {
          _this.url.searchParams.append(queryKey, a1[queryKey]);
        });
      } else this.url.searchParams.append(a1, a2);

      return this;
    }
  }, {
    key: "path",
    value: function path(relativePath) {
      this.url.pathname = _path.join(this.url.pathname, relativePath);
      return this;
    }
  }, {
    key: "body",
    value: function body(data, sendAs) {
      this.sendDataAs = typeof data === 'object' && !sendAs && !Buffer.isBuffer(data) ? 'json' : sendAs ? sendAs.toLowerCase() : 'buffer';
      this.data = this.sendDataAs === 'form' ? qs.stringify(data) : this.sendDataAs === 'json' ? JSON.stringify(data) : data;
      return this;
    }
  }, {
    key: "header",
    value: function header(a1, a2) {
      var _this2 = this;

      if (typeof a1 === 'object') {
        Object.keys(a1).forEach(function (headerName) {
          _this2.reqHeaders[headerName.toLowerCase()] = a1[headerName];
        });
      } else this.reqHeaders[a1.toLowerCase()] = a2;

      return this;
    }
  }, {
    key: "timeout",
    value: function timeout(_timeout) {
      this.timeoutTime = _timeout;
      return this;
    }
  }, {
    key: "option",
    value: function option(name, value) {
      this.coreOptions[name] = value;
      return this;
    }
  }, {
    key: "stream",
    value: function stream() {
      this.streamEnabled = true;
      return this;
    }
  }, {
    key: "compress",
    value: function compress() {
      this.compressionEnabled = true;
      if (!this.reqHeaders['accept-encoding']) this.reqHeaders['accept-encoding'] = supportedCompressions.join(', ');
      return this;
    }
  }, {
    key: "send",
    value: function send() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        if (_this3.data) {
          if (!_this3.reqHeaders.hasOwnProperty('content-type')) {
            if (_this3.sendDataAs === 'json') {
              _this3.reqHeaders['content-type'] = 'application/json';
            } else if (_this3.sendDataAs === 'form') {
              _this3.reqHeaders['content-type'] = 'application/x-www-form-urlencoded';
            }
          }

          if (!_this3.reqHeaders.hasOwnProperty('content-length')) {
            _this3.reqHeaders['content-length'] = Buffer.byteLength(_this3.data);
          }
        }

        var options = Object.assign({
          'protocol': _this3.url.protocol,
          'host': _this3.url.hostname,
          'port': _this3.url.port,
          'path': _this3.url.pathname + _this3.url.search,
          'method': _this3.method,
          'headers': _this3.reqHeaders
        }, _this3.coreOptions);
        var req;

        var resHandler = function resHandler(res) {
          var stream = res;

          if (_this3.compressionEnabled) {
            if (res.headers['content-encoding'] === 'gzip') {
              stream = res.pipe(zlib.createGunzip());
            } else if (res.headers['content-encoding'] === 'deflate') {
              stream = res.pipe(zlib.createInflate());
            }
          }

          var centraRes;

          if (_this3.streamEnabled) {
            resolve(stream);
          } else {
            centraRes = new CentraResponse(res, _this3.resOptions);
            stream.on('error', function (err) {
              reject(err);
            });
            stream.on('data', function (chunk) {
              centraRes._addChunk(chunk);

              if (_this3.resOptions.maxBuffer !== null && centraRes.body.length > _this3.resOptions.maxBuffer) {
                stream.destroy();
                reject('Received a response which was longer than acceptable when buffering. (' + _this3.body.length + ' bytes)');
              }
            });
            stream.on('end', function () {
              resolve(centraRes);
            });
          }
        };

        if (_this3.url.protocol === 'http:') {
          req = http.request(options, resHandler);
        } else if (_this3.url.protocol === 'https:') {
          req = https.request(options, resHandler);
        } else throw new Error('Bad URL protocol: ' + _this3.url.protocol);

        if (_this3.timeoutTime) {
          req.setTimeout(_this3.timeoutTime, function () {
            req.abort();

            if (!_this3.streamEnabled) {
              reject(new Error('Timeout reached'));
            }
          });
        }

        req.on('error', function (err) {
          reject(err);
        });
        if (_this3.data) req.write(_this3.data);
        req.end();
      });
    }
  }]);

  return CentraRequest;
}();